module.exports = __webpack_public_path__ + "static/media/no-image.294de88d.jpg";